import MyGoal1 from "../../../../assets/img/icon1.png";
import MyGoal2 from "../../../../assets/img/icon2.png";
import MyGoal3 from "../../../../assets/img/icon3.png";
import MyGoal4 from "../../../../assets/img/icon4.png";
import MyGoal5 from "../../../../assets/img/icon5.png";
import MyGoal6 from "../../../../assets/img/icon6.png";
import { Link } from "react-router-dom";
const AssociateReferalTeam = () => {
  return (
    <div className="col-12 col-xl-6 ">
      <div className="card border   w-100 overflow-hidden">
        <div className="card-body  p-2">
          <div class="card-title ">
            <h4 class="text-body-emphasis text-color">Associate Activity</h4>
          </div>
          <ul class="goal-icon column-gap-2">
            <li className="card  border">
              <Link to="/AssoActivity/MyGoal">
                <img
                  class="card-img-top mb-3 d-block text-center m-auto"
                  src={MyGoal1}
                  alt=""
                />
                <strong className="text-center">Goal</strong>
              </Link>
            </li>
            <li className="card p-5 border">
              <Link to="/AssoActivity/BusinessCard">
                <img
                  class="card-img-top mb-3 d-block text-center m-auto"
                  src={MyGoal2}
                  alt=""
                />
                <strong>Business Card</strong>
              </Link>
            </li>
            <li className="card p-5 border">
              <Link to="/AssoActivity/MyBrochure">
                <img
                  class="card-img-top mb-3 d-block text-center m-auto"
                  src={MyGoal3}
                  alt=""
                />
                <strong>My Brochure</strong>
              </Link>
            </li>
            <li className="card p-5 border">
              <a href="javascript:void(0)">
                <img
                  class="card-img-top mb-3 d-block m-auto"
                  src={MyGoal4}
                  alt=""
                />
                <strong className="d-inline-flex ">E-book</strong>&nbsp;
                <small>coming soon</small>
              </a>
            </li>

            <li className="card p-5 border">
              <a href="javascript:void(0)">
                <img
                  class="card-img-top mb-3 d-block text-center m-auto"
                  src={MyGoal5}
                  alt=""
                />
                <strong className="d-inline-flex ">Audiobook</strong>&nbsp;
                <small>coming soon</small>
              </a>
            </li>

            <li className="card p-5 border">
              <a href="javascript:void(0)">
                <img
                  class="card-img-top mb-3 d-block text-center m-auto"
                  src={MyGoal6}
                  alt=""
                />
                <strong className="d-inline-flex ">Video Conference</strong>
                &nbsp;
                <small>coming soon</small>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AssociateReferalTeam;
